export type UseLibraryStrategy = {
  type: string;
  slugs: ComputedRef<string[]>;
  setRoute: (path: string) => void;
  goBack: () => void;
  path: ComputedRef<string>;
  hasPrevious: ComputedRef<boolean>;
};

export const useLibraryStrategy = (
  type: 'page' | 'form'
): UseLibraryStrategy => {
  if (type === 'page') {
    return useLibraryStrategyPage();
  } else {
    return useLibraryStrategyForm();
  }
};
